/** @type {import("tailwindcss").Config} */
const config = {
	darkMode: "class",
	content: [
		"./assets/**/*.{vue,js,css}",
		"./components/**/*.{vue,js}",
		"./layouts/**/*.vue",
		"./pages/**/*.vue",
		"./plugins/**/*.{js,ts}",
		"./nuxt.config.{js,ts}",
	],
	safelist: [
		"grid-cols-10",
		"flex",
		"justify-start",
		"place-items-center",
		"place-items-center",
		"w-full",
		"grid",
		"gap-2",
		"p-5",
		"mb-2",
		"mt-2",
		"col-span-8",
		"col-span-10",
		"col-span-2",
		"md:col-span-1",
		"md:col-span-4",
		"md:col-span-5",
	],
	theme: {
		fontFamily: {
			sans: ["Roboto", "sans-serif"],
			BigShouldersDisplay: ["BigShouldersDisplay", "Roboto"],
		},
		fontSize: {
			xs: "12px",
			sm: "14px",
			base: "16px",
			lg: "18px",
			xl: "20px",
			"2xl": "22px",
			"3xl": "20px",
			"4xl": "24px",
			"5xl": "28px",
			"6xl": "32px",
		},
		colors: {
			identity: "var(--color-identity)",
			"identity-hover": "var(--color-identity-hover)",
			"identity-50": "var(--color-identity-50)",
			"identity-100": "var(--color-identity-100)",
			"identity-200": "var(--color-identity-200)",
			"identity-300": "var(--color-identity-300)",
			"identity-400": "var(--color-identity-400)",
			"identity-500": "var(--color-identity-500)",
			"identity-600": "var(--color-identity-600)",
			"identity-700": "var(--color-identity-700)",
			"identity-800": "var(--color-identity-800)",
			"identity-900": "var(--color-identity-900)",
			insurance: "#3D94D1",
			primary: {
				50: "#E0F3E0",
				100: "#B3E0B3",
				200: "#80CC80",
				300: "#4DB84D",
				400: "#26A826",
				500: "#009900",
				600: "#009100",
				700: "#008600",
				800: "#007C00",
				900: "#006B00",
			},
			dark: {
				50: "#A3A3A3",
				100: "#939393",
				200: "#838383",
				300: "#737373",
				400: "#636363",
				500: "#535353",
				600: "#434343",
				700: "#333333",
				800: "#232323",
				900: "#000000",
			},
			light: {
				50: "#FFFFFF",
				100: "#FAFAFA",
				200: "#F1F1F1",
				300: "#EAEAEA",
				400: "#E1E1E1",
				500: "#DADADA",
				600: "#D1D1D1",
				700: "#CACACA",
				800: "#C1C1C1",
				900: "#B1B1B1",
			},
			casino: {
				50: "#E0EDFF",
				100: "#B3D1FF",
				200: "#80B3FF",
				300: "#4D94FF",
				400: "#267DFF",
				500: "#0066ff",
				600: "#005eff",
				700: "#0053ff",
				800: "#0049ff",
				900: "#0038ff",
			},
			esports: {
				50: "#F1E6F2",
				100: "#DDBFE0",
				200: "#C796CD",
				300: "#B06EB8",
				400: "#9F52A9",
				500: "#8F399A",
				600: "#833594",
				700: "#722F8B",
				800: "#632A81",
				900: "#48216F",
			},
			live: {
				50: "#E2F6FA",
				100: "#B7E8F3",
				200: "#8BD9EB",
				300: "#66CAE0",
				400: "#54BFD7",
				500: "#48B4D0",
				600: "#43A5BD",
				700: "#3B90A3",
				800: "#347C8B",
				900: "#265A61",
			},
			vegas: {
				50: "#FEE4EA",
				100: "#FCBBCB",
				200: "#F98FA8",
				300: "#F66286",
				400: "#F1416D",
				500: "#ED2355",
				600: "#DD1E53",
				700: "#C7184F",
				800: "#B3114D",
				900: "#8F0547",
			},
			virtuals: {
				50: "#DFF1F2",
				100: "#AFDCDC",
				200: "#7AC6C6",
				300: "#41B0AE",
				400: "#049F9D",
				500: "#008E8A",
				600: "#00827C",
				700: "#00726C",
				800: "#00625C",
				900: "#00473F",
			},
			warning: {
				50: "#FFF3E0",
				100: "#FFDFB2",
				200: "#FFCB7F",
				300: "#FFB64C",
				400: "#FFA525",
				500: "#FF9600",
				600: "#FB8A00",
				700: "#F57A01",
				800: "#EF6A01",
				900: "#E64F01",
			},
			error: {
				50: "#FFECEF",
				100: "#FFCED4",
				200: "#F99C9D",
				300: "#F37476",
				400: "#FF5252",
				500: "#FF3E36",
				600: "#F73536",
				700: "#E42930",
				800: "#D72028",
				900: "#C8111C",
			},
			rewards: {
				primary: "#F0C009",
				secondary: "#DA971B",
			},
		},
		extend: {
			screens: {
				xl: "1281px",
			},
			container: {
				screens: {
					"2xl": "1611px",
				},
			},
			height: {
				screen: ["100vh" /* fallback for Opera, IE and etc. */, "100dvh"],
			},
			maxHeight: {
				screen: ["100vh" /* fallback for Opera, IE and etc. */, "100dvh"],
			},
			boxShadow: {
				glow: "0 0 0 0 rgba(0, 0, 0, 0.3)",
			},
			animation: {
				'infinite-scroll': 'infinite-scroll 35s linear infinite',
			  },
			  keyframes: {
				'infinite-scroll': {
					from: { transform: 'translateX(0)' },
					to: { transform: 'translateX(-100%)' },
				  }
			}
		},
	},
	plugins: [],
};

export default config;
